// extracted by mini-css-extract-plugin
export default {"eachSlideEffect":"Slideshow_eachSlideEffect__mKNq+"};